import React from 'react'
import PropTypes from 'prop-types'
import pure from 'recompose/pure'
import Tags from 'components/Tags'
import Section from './Section'

const PopularTags = ({ header, tags }) => {
  const tagsWithCounters = generateCounts(accumulateTags(tags))

  const top20Tags = Object.keys(tagsWithCounters)
    .sort((a, b) => {
      const tagA = tagsWithCounters[a]
      const tagB = tagsWithCounters[b]
      return tagB - tagA
    })
    .slice(0, 20)

  return <Section header={header} render={() => <Tags tags={top20Tags} />} />
}

PopularTags.propTypes = {
  header: PropTypes.string.isRequired,
  tags: PropTypes.array,
}

function accumulateTags(allTags) {
  return allTags.reduce((acc, node) => {
    const tags = !!node && 'node' in node ? node.node : node
    acc.push(...tags.frontmatter.tags)
    return acc
  }, [])
}

// items = string[]
function generateCounts(items) {
  if (!Array.isArray(items)) {
    throw new Error('You must pass in an iterator in order to generate counts')
  }

  return items.reduce((acc, item) => {
    const copyAcc = { ...acc }
    if (!copyAcc[item]) copyAcc[item] = 0
    typeof copyAcc[item] === 'number' && copyAcc[item]++ // eslint-disable-line
    return copyAcc
  }, {})
}

export default pure(PopularTags)



// WEBPACK FOOTER //
// ./src/components/Sidebar/PopularTags.js